import { Component, OnInit, EventEmitter } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
@Component({
  selector: 'abtest-settings-change-percent-dialog',
  templateUrl: './abtest-settings-change-percent-dialog.component.html',
  styleUrls: ['./abtest-settings-change-percent-dialog.component.scss'],
  standalone: false,
})
export class AbtestSettingsChangePercentDialogComponent implements OnInit {
  onSave = new EventEmitter<void>();
  constructor(public dialogRef: MatDialogRef<AbtestSettingsChangePercentDialogComponent>) {}

  ngOnInit() {}

  save() {
    this.onSave.emit();
  }
}
